import styled from "styled-components";
import { Body, shade300 } from "@songtradr-one/components-frontend";
import { graphql } from "../../../generated/gql";
import { staticText } from "../../../shared/statics/static-text";
import type { NotificationsPanelTab } from "../NotificationsPanel.Parts";

// TEXT
export const text = staticText.panel;

// STYLES
export const PanelList = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  padding-top: 0.5rem;
  overflow-y: auto;
`;

export const EmptyState = styled(Body)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24rem;
  padding: 1.5rem;
  text-align: center;
  color: ${shade300};
`;

// DATA
export const NotificationsPanelList_Query = graphql(`
  query NotificationsPanelList($limit: Int!, $offset: Int!) {
    notifications {
      user(limit: $limit, offset: $offset) {
        items {
          id
          status
          ...NotificationItem
        }
        total
      }
    }
  }
`);

export const NotificationsPanelList_Subscription = graphql(`
  subscription NotificationsPanelListFeed {
    newNotification
  }
`);

// TYPES
export type Props = {
  activeTab: NotificationsPanelTab;
  onNavigate?: () => void;
};

// CONSTANTS
export const PAGE_SIZE = 100;
export const SKELETON_COUNT = 5;

// FUNCTIONS

// ASSETS
